import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ReactNode } from "react";

type ConfirmationModalProps = {
  show: boolean;
  close: () => void;
  action: "Remove" | "Churn" | "Dissolve" | "Delete" | "Restore";
  actionOn: "group" | "profile";
  handleClick: () => void;
  isLoading: boolean;
  title?: string;
  body?: ReactNode;
};

export const ConfirmationModal = ({
  show,
  close,
  action,
  actionOn,
  handleClick,
  isLoading,
  title,
  body,
}: ConfirmationModalProps) => {
  const onClick = () => {
    handleClick();
    close();
  };

  return (
    <Modal.Root open={show} onOpenChange={close}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{title ?? `${action} this ${actionOn}?`}</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-lg t-text-text-black">
            {body ??
              `Are you sure you want to ${action.toLowerCase()} this ${actionOn}?`}
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button onClick={close}>Cancel</Button>
          </Modal.RawClose>
          <Button
            customType={action === "Restore" ? "primary" : "danger"}
            onClick={onClick}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
